export function getCurrentMailItem(): Office.MessageRead | undefined {
  return Office.context.mailbox?.item as Office.MessageRead | undefined;
}

export function getItemSubject(): string | undefined {
  return getCurrentMailItem()?.subject;
}

export function getItemBody(
  coercionType: Office.CoercionType = Office.CoercionType.Text
): Promise<string> {
  return new Promise((resolve, reject) => {
    const item = getCurrentMailItem();
    if (!item) {
      reject(new Error("No mail item available."));
      return;
    }
    item.body.getAsync(coercionType, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        reject(new Error(result.error.message));
      }
    });
  });
}

export function getSenderEmail(): string | undefined {
  return getCurrentMailItem()?.from?.emailAddress;
}
